import { CardValidationErrors } from "./validationErrors";
export var isCvvValid = function (cvc, cardType) {
    if (!cvc) {
        return { valid: false, error: CardValidationErrors.emptyCVV };
    }
    if (cvc.length < 3) {
        return { valid: false, error: CardValidationErrors.invalidCVV };
    }
    if (cardType && cvc.length !== cardType.code.length) {
        return { valid: false, error: CardValidationErrors.invalidCVV };
    }
    if (cardType && cvc.length == cardType.code.length) {
        return { valid: true, error: "" };
    }
    return { valid: false, error: CardValidationErrors.invalidCVV };
};
